<template>
    <bottom-sheet v-model="shows" title="근로계약 출근QR" fullscreen persistent width="720" maxWidth="100%">
        <template #activator="bind">
            <slot name="activator" v-bind="bind" />
        </template>
        <v-layout column justify-center class="bottom-sheet__contents h-100">
            <v-sheet style="flex: 1 1 auto; overflow-x: hidden; overflow-y: auto" class="scroll-primary">
                <v-layout justify-center align-center class="pa-20 pa-md-30 pa-lg-40">
                    <qrcode-vue :value="value_qr" :size="$vuetify.breakpoint.mdAndUp ? 450 : 145" class="d-flex justify-center" ref="qrcode-vue" />
                </v-layout>
            </v-sheet>
            <div class="v-btn-group flex-wrap">
                <v-btn outlined color="grey-d" class="min-w-140px min-w-lg-160px" v-bind="{ loading }" @click="shows = false">
                    <span class="grey-6--text"> 닫기 </span>
                </v-btn>
                <v-btn color="primary" class="min-w-140px min-w-lg-160px" v-bind="{ loading }" @click="down">
                    <span> 다운로드 </span>
                </v-btn>
            </div>
        </v-layout>
    </bottom-sheet>
</template>

<script>
import api from "@/api";
import download from "downloadjs";
import { initAttendanceCode } from "@/store/attendance";

import BottomSheet from "@/components/dumb/bottom-sheet.vue";
import QrcodeVue from "qrcode.vue";
export default {
    components: {
        BottomSheet,
        QrcodeVue,
    },
    props: {
        value: { type: Object, default: initAttendanceCode },
    },
    data: () => ({
        form: initAttendanceCode(),

        shows: false,
        loading: false,
    }),
    computed: {
        value_qr() {
            let { _id: _code } = this.form;
            return JSON.stringify({ _code });
        },
    },
    methods: {
        async init() {
            this.loading = true;
            try {
                const { code } = await api.v1.company.attendance.codes.get({ _id: this.value?._id });
                this.$emit("input", code);
                this.form = initAttendanceCode(code);
            } finally {
                this.loading = false;
            }
        },

        down() {
            if (this.loading) return;
            else this.loading = true;

            let intervalId = setInterval(() => {
                let el = this.$refs["qrcode-vue"]?.$el;
                if (!el) return;

                let canvas = el?.getElementsByTagName?.("canvas")?.[0];
                if (!canvas) return;

                let url = canvas?.toDataURL?.();
                if (!url) return;

                download(url, `${this.form?.name}-qr_code.png`);

                clearInterval(intervalId);
                this.loading = false;
            }, 10);
        },
    },
    watch: {
        shows() {
            if (this.shows) this.init();
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .text-right input {
        text-align: right;
    }
    .v-input--switch label {
        margin-bottom: 4px;
    }
    .v-textarea textarea {
        margin: 0 !important;
        padding-top: 8px;
        line-height: 1.875em;
    }
}
</style>
